<template>
  <div>
    <BankCardAdd @addbank="addbank" @reback="reback"></BankCardAdd>
  </div>
</template>

<script>
import BankCardAdd from '../../views/accountManagement/bankCardManage/bankCardAdd.vue';
export default {
  name: "addBank",
  components: {
    BankCardAdd
  },
  data () {
    return {
    }
  },
  methods: {
    addbank(val) {
      this.$emit('addbank', val)
    },
    reback(val) {
      this.$emit('addbank', val)
    }
  }
}
</script>

<style lang="less" scoped>
</style>